import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { useState } from 'react';
import Faq from '../pages/Faq';
import Qreate from '../pages/Qreate';
import Qethics from '../pages/Qethics';
import Resources from '../pages/Resources';
import Schedule from '../pages/Schedule';
import Registration from '../pages/Registration';
import Home from '../pages/Home';
import QEE from '../pages/QEE';
import '../styles/Navbar.css';
import SignUp from '../pages/auth/SignUp';
import Oshiro from '../pages/speakers/scottoshiro';
import Serrano from '../pages/speakers/danielserrano';
import Benally from '../pages/speakers/onrijaybenally';
import Florenta from '../pages/speakers/florentateodoridis';
import Pundyk from '../pages/speakers/katepundyk';
import Spedalieri from '../pages/speakers/spedalieri';
import Rosa from '../pages/speakers/rosadifelice';
import Bruce from '../pages/speakers/bruce';
import Halpern from '../pages/speakers/nicoleyungerhalpern';
import Amelie from '../pages/speakers/amelie';
import Myungin from '../pages/speakers/myungin';
import Jonathan from '../pages/speakers/jonathan';
import Alexander from '../pages/speakers/alexander';
import Lucy from '../pages/speakers/lucy';
import JonathanM from '../pages/speakers/jonathanmartin';
import Eric from '../pages/speakers/eric';
import Marcello from '../pages/speakers/marcello';
import Adrian from '../pages/speakers/adrian';
import Ricky from '../pages/speakers/ricky';
import CQN from '../pages/challenges/cqn';
import Organizers from '../pages/Organizers';

function Navbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };
  const toggleMenu = () => {
    setMenuOpen((open) => !open);
    setDropdownOpen(false);
  };
  const closeMenu = () => {
    setMenuOpen(false);
    setDropdownOpen(false);
  };

  return (
    <Router>
      <nav className="navbar">
        {/* Hamburger for mobile only, hidden by CSS above 700px */}
        <div
          className={`navbar-hamburger${menuOpen ? ' open' : ''}`}
          onClick={toggleMenu}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          tabIndex={0}
          role="button"
          onKeyPress={e => (e.key === 'Enter' || e.key === ' ') && toggleMenu()}
        >
          <div className="navbar-hamburger-bar bar1"></div>
          <div className="navbar-hamburger-bar bar2"></div>
          <div className="navbar-hamburger-bar bar3"></div>
        </div>
        {/* Desktop nav stays the same, mobile nav toggles open/close */}
        <div className={`Navbar navbar-links${menuOpen ? ' open' : ''}`}>
          <Link to="/" onClick={closeMenu} style={{ textDecoration: 'none'}}>Home</Link>
          <div className='dropdown'>
            <span onClick={toggleDropdown}>About ▾</span>
            <div className={`dropdown-content ${dropdownOpen ? 'show' : ''}`}>
              <Link to="/qreate" onClick={closeMenu} style={{ textDecoration: 'none'}}>Qreate @ UMD</Link>
              <Link to="/qethics" onClick={closeMenu} style={{ textDecoration: 'none'}}>Qompute @ USC</Link>
            </div>
          </div>
          <Link to="/registration" onClick={closeMenu} style={{ textDecoration: 'none'}}>Registration</Link>
          <Link to="/resources" onClick={closeMenu} style={{ textDecoration: 'none'}}>Resources</Link> 
          <Link to="/faq" onClick={closeMenu} style={{ textDecoration: 'none'}}>FAQ</Link>
          <Link to="/schedule" onClick={closeMenu} style={{ textDecoration: 'none'}}>Schedule</Link>
          {/* NEW: Meet the Team (after Schedule) */}
          <Link to="/organizers-dev" onClick={closeMenu} style={{ textDecoration: 'none'}}>Meet the Team</Link>
        </div>
      </nav>
      <div className='content'> 
        <Routes>
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/" element={<Home />} />
          <Route path="/qreate" element={<Qreate />} />
          <Route path="/qethics" element={<Qethics />} />
          <Route path="/resources" element={<Resources />} /> 
          <Route path="/registration" element={<Registration />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/QEE" element={<QEE/>}/>
          <Route path="/signup" element={<SignUp />} />
          <Route path="/oshiro" element={<Oshiro />}/>
          <Route path="/serrano" element={<Serrano />}/>
          <Route path="/benally" element={<Benally />}/>
          <Route path="/florenta" element={<Florenta />} />
          <Route path="/kate" element={<Pundyk />} />
          <Route path="/spedalieri" element={<Spedalieri />} />
          <Route path="/rosa" element={<Rosa />} />
          <Route path="/bruce" element={<Bruce />} />
          <Route path="/halpern" element={<Halpern />} />
          <Route path="/amelie" element={<Amelie />} />
          <Route path="/myungin" element={<Myungin />} />
          <Route path="/cqn" element={<CQN />} />
          <Route path="/jonathan" element={<Jonathan />} />
          <Route path="/alexander" element={<Alexander />} />
          <Route path="/lucy" element={<Lucy />} />
          <Route path="/jonathanmartin" element={<JonathanM />} />
          <Route path="/eric" element={<Eric />} />
          <Route path="/marcello" element={<Marcello />} />
          <Route path="/organizers-dev" element={<Organizers />} />
          <Route path="/adrian" element={<Adrian />} />
          <Route path="/ricky" element={<Ricky />} />
        </Routes>
      </div>
    </Router>
  );
}

export default Navbar;
